import { render, staticRenderFns } from "./BlackCard.vue?vue&type=template&id=2feff192&lang=pug&"
import script from "./BlackCard.vue?vue&type=script&lang=js&"
export * from "./BlackCard.vue?vue&type=script&lang=js&"
import style0 from "./BlackCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports